exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.eventEditBody[data-v-ec31fdea] {\n  min-height: 460px;\n}\n.loading-overlay[data-v-ec31fdea] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  z-index: 5;\n}\n.overflow-test[data-v-ec31fdea] {\n  height: 70.9vh;\n  overflow: auto;\n}\n.tab-error-dot[data-v-ec31fdea] {\n  width: 8px;\n  height: 8px;\n  background: #d64545;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 8px;\n}\n.event-changed-banner[data-v-ec31fdea] {\n  max-height: 0;\n  padding: 0;\n  transition: all ease-in-out 400ms;\n  height: 0;\n  overflow: hidden;\n}\n.event-changed-banner.active[data-v-ec31fdea] {\n    max-height: none;\n    padding: 0.25rem 0;\n    height: 1.9rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-ec31fdea","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/tools/modal/EventEdit.vue
// module id = 1408
// module chunks = 0